import { Box, Stack, styled, Typography } from '@mui/material'
import { Outlet, Route, Routes } from 'react-router-dom'
import SubpageTabs, { SubpageTabLink } from 'components/SubpageTabs'
import MyTwinProfile from './MyTwinProfile'
import MyTwinNotes from './MyTwinNotes'
import MyTwinEmails from './MyTwinEmails'
import MyTwinCalendars from './MyTwinCalendars'
import MyTwinFiles from './MyTwinFiles'
import MyTwinInstructions from './MyTwinInstructions'
import MyTwinSharing from './MyTwinSharing'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { COLORS } from 'app-constants'

const MainBox = styled(Box)`
  width: 100%;
`

export default function MyTwin() {
  return (
    <Routes>
      <Route element={<MyTwinContainer />}>
        <Route index element={<MyTwinProfile />} />
        <Route path="/sharing" element={<MyTwinSharing />} />
        <Route path="/instructions" element={<MyTwinInstructions />} />
        <Route path="/notes" element={<MyTwinNotes />} />
        <Route path="/emails" element={<MyTwinEmails />} />
        <Route path="/calendars" element={<MyTwinCalendars />} />
        <Route path="/files" element={<MyTwinFiles />} />
      </Route>
    </Routes>
  )
}

const Sidebar = () => {
  return (
    <Stack
      p={3}
      height="100vh"
      width="256px"
      sx={{
        background: COLORS.PURE_WHITE,
      }}>
      <Typography variant="h4" mb="49px">
        My Twin
      </Typography>

      <Typography
        variant="pXS"
        mb={3}
        sx={{
          color: COLORS.GRAY_4,
        }}>
        PROFILE
      </Typography>

      <SubpageTabs>
        <SubpageTabLink to="/my-twin" label="Description" />
        <SubpageTabLink to="/my-twin/sharing" label="Sharing" />
      </SubpageTabs>

      <Typography
        variant="pXS"
        my={3}
        sx={{
          color: COLORS.GRAY_4,
        }}>
        KNOWLEDGE BASE
      </Typography>

      <SubpageTabs>
        <SubpageTabLink to="/my-twin/notes" label="Notes" />
        <SubpageTabLink to="/my-twin/emails" label="Emails" />
        <SubpageTabLink to="/my-twin/calendars" label="Calendars" />
        <SubpageTabLink to="/my-twin/files" label="Files" />
        <SubpageTabLink to="/my-twin/instructions" label="Instructions" />
      </SubpageTabs>
    </Stack>
  )
}

const MyTwinContainer = () => {
  const isMobile = useCheckMobileScreen()

  return (
    <Stack>
      {isMobile ? (
        <Stack
          direction="column"
          spacing={2}
          justifyContent="flex-start"
          sx={{
            backgroundColor: COLORS.PURE_WHITE,
          }}>
          <MainBox
            style={{
              paddingRight: isMobile ? 0 : '32px',
            }}>
            <Outlet />
          </MainBox>
        </Stack>
      ) : (
        <Stack direction="row" spacing={0} justifyContent="flex-start">
          <Sidebar />
          <MainBox
            style={{
              overflowY: 'scroll',
              height: '100vh',
            }}>
            <Outlet />
          </MainBox>
        </Stack>
      )}
    </Stack>
  )
}
